import {keyBy} from "lodash";

export const buildReportParams = (reports, values) => {
    const {reportName, ...restValues} = values;

    const params = {};

    const existsValues = Object.entries(restValues ?? {}).filter(([fieldKey, fieldValue]) => !!fieldValue);

    for (const [fieldKey, fieldValue] of existsValues) {
        const reportSettingsByReportName = keyBy(reports, report => report?.key);
        const fieldSettings = reportSettingsByReportName?.[reportName]?.fields?.[fieldKey];
        params[fieldKey] =
            fieldSettings?.transform && typeof fieldSettings.transform === "function"
                ? fieldSettings.transform(fieldValue)
                : fieldValue;
    }

    return {
        reportName,
        ...(Object.keys(params ?? {})?.length ? {params} : {})
    };
};
